module.exports = __webpack_public_path__ + "static/img/8en.0bda3b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/8en.png
// module id = dzhJ
// module chunks = 0